var _defs, _metadata, _rect, _g, _g2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "59.6195mm",
    height: "59.6195mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1714 1714",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str3 {stroke:black;stroke-width:40.5601}\r\n    .str0 {stroke:black;stroke-width:50.698}\r\n    .str4 {stroke:black;stroke-width:50.698;stroke-linejoin:round}\r\n    .str1 {stroke:black;stroke-width:50.698;stroke-linecap:round}\r\n    .str6 {stroke:black;stroke-width:30.4194;stroke-linecap:round;stroke-linejoin:round}\r\n    .str5 {stroke:black;stroke-width:30.4194;stroke-linecap:round;stroke-linejoin:round}\r\n    .str2 {stroke:black;stroke-width:50.698;stroke-linecap:round;stroke-linejoin:round}\r\n    .fil0 {fill:none}\r\n    .fil3 {fill:black}\r\n    .fil2 {fill:black}\r\n    .fil6 {fill:#336699}\r\n    .fil7 {fill:#FF6600}\r\n    .fil1 {fill:yellow}\r\n    .fil5 {fill:white}\r\n    .fil4 {fill:red;fill-rule:nonzero}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 120l1654 0 0 1474 -1654 0 0 -1474z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1714,
    height: 1714
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil1 str0",
    transform: "matrix(0.558475 -0.0861782 0.0861782 0.558475 282.39 232.045)",
    width: 763,
    height: 619
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil2",
    points: "408,321 440,279 516,335 573,258 615,289 559,366 636,423 605,465 528,409 471,486 429,454 485,378 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil2",
    transform: "matrix(0.589903 -0.091028 0.091028 0.589903 524.839 548.302)",
    width: 81.1202,
    height: 598.267
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1065 817c0,0 0,0 0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M312 684c-81,116 68,67 -26,182"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M204 684c-82,116 68,67 -26,182"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M420 684c-81,116 69,67 -26,182"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil4 str2",
    points: "998,760 998,260 1625,260 1625,760 1265,760 1052,944 1123,760 "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil5 str0",
    transform: "matrix(0.449695 0.449695 -0.449695 0.449695 1313.19 506.889)",
    r: 256
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil0 str0",
    x1: 1428,
    y1: 392,
    x2: 1198,
    y2: 622
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil6 str3",
    cx: 282,
    cy: 1054,
    r: 111
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6 str4",
    d: "M197 1240l225 0 102 -122c20,-24 30,-57 30,-88l0 -191 121 0 0 242c-1,27 -11,56 -28,77l-151 186c0,4 0,8 0,12l0 448c0,64 -52,116 -116,116l-183 0c-64,0 -117,-52 -117,-116l0 -448c0,-64 53,-116 117,-116z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil6 str3",
    cx: 865,
    cy: 1091,
    r: 94
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6 str4",
    d: "M792 1249l192 0 242 -269 79 69 -258 288c0,4 0,7 0,11l0 380c0,55 -44,99 -99,99l-156 0c-54,0 -98,-44 -98,-99l0 -380c0,-55 44,-99 98,-99z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil7 str5",
    points: "1221,1648 1151,1422 1254,1490 1212,1324 1328,1388 1344,1232 1413,1298 1506,1200 1476,1393 1606,1379 1480,1507 1594,1547 1419,1700 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil7 str6",
    points: "1553,1307 1607,1090 1655,1177 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil7 str6",
    points: "1416,1191 1381,1063 1468,1026 "
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "30,120 1684,120 1684,1594 30,1594 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtest);
export default __webpack_public_path__ + "static/media/protest.77efe74d3f530731d387380bb42e0fc0.svg";
export { ForwardRef as ReactComponent };